module.exports = __webpack_public_path__ + "img/noviceTip.1420bf85.png";